import { InvariantTemplate } from '@ess/jg-rule-executor';
import { ToJsonInputTranslatable } from '@src/app/model/to-json-input-translatable';
import { BlueprintInvariantTemplateInput } from '@src/app/generated/globalTypes';
import { GetModuleInvariantTemplates_moduleInvariantTemplates } from '@src/app/generated/GetModuleInvariantTemplates';
import { GetEnvInvariantTemplates_envInvariantTemplates } from '@src/app/generated/GetEnvInvariantTemplates';
import { PortalModuleBlueprint } from '@src/app/model/portal-module-blueprint';
import { PortalInvariant } from '@src/app/model/portal-invariant';

export class PortalInvariantTemplate extends InvariantTemplate implements ToJsonInputTranslatable {
  declare invariants: PortalInvariant[];

  static fromGql(
    gql: GetModuleInvariantTemplates_moduleInvariantTemplates | GetEnvInvariantTemplates_envInvariantTemplates
  ): PortalInvariantTemplate {
    return new PortalInvariantTemplate(
      gql.id,
      gql.invariants.map(i => new PortalInvariant(
        i.id, i.rule, PortalInvariant.keysFromGql(i.translationKeys),
        PortalInvariant.translationsFromGql(i.translations), i.correction, i.name, i.disableDuringOnChange
      )),
      gql.name
    );
  }

  toGqlInput(): BlueprintInvariantTemplateInput {
    return {
      name: this.name,
      invariants: this.invariants.map(i => PortalModuleBlueprint.invariantToGqlInput(i)),
    };
  }
}
